import { render, staticRenderFns } from "./Navbar-v2.vue?vue&type=template&id=04199ff2&scoped=true&"
import script from "./Navbar-v2.vue?vue&type=script&lang=js&"
export * from "./Navbar-v2.vue?vue&type=script&lang=js&"
import style0 from "./Navbar-v2.vue?vue&type=style&index=0&id=04199ff2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04199ff2",
  null
  
)

export default component.exports